import React from 'react'

import Header from '../Header'
import Form from './Form'
import { Container } from './styled'

function ForgotPassword() {
  return (
    <Container>
      <Header />
      <Form />
    </Container>
  )
}

export default ForgotPassword